const EJOURNAL_CUSTODIAN_REQUIRED_HQ_STATES = ['North Carolina', 'NC'];

export interface EjournalCustodianProfileFields {
  eJournalCustodianEmail?: string | null;
  eJournalCustodianName?: string | null;
}

/**
 * Returns true when the company is in NC state.
 * @param company - The company to check.
 * @returns True when the company is in NC state, false otherwise.
 */
export function isCustodianInfoRequired(
  company?: { hqState?: string | null } | null,
): boolean {
  if (!company?.hqState) return false;
  return EJOURNAL_CUSTODIAN_REQUIRED_HQ_STATES.includes(company.hqState);
}

/**
 * Returns true when the company is NC-based and the profile is missing custodian name or email.
 */
export function needsCustodianInfo(
  company?: { hqState?: string | null } | null,
  profile?: EjournalCustodianProfileFields | null,
): boolean {
  if (!company?.hqState) return false;
  if (!EJOURNAL_CUSTODIAN_REQUIRED_HQ_STATES.includes(company.hqState)) {
    return false;
  }
  if (!profile) return false;
  return !(profile.eJournalCustodianEmail && profile.eJournalCustodianName);
}
